import { ErrorStatusPage } from './ErrorStatusPage';

export interface ServerErrorPageProps {
    onRetry?: () => void;
    message?: string;
}

export function ServerErrorPage({ onRetry, message }: ServerErrorPageProps) {
    return (
        <ErrorStatusPage
            code={500}
            title="خطأ في الخادم"
            description={
                message ||
                'حدث خطأ غير متوقع أثناء معالجة طلبك. يرجى المحاولة مرة أخرى بعد قليل، أو العودة للصفحة الرئيسية.'
            }
            onRetry={onRetry || (() => window.location.reload())}
            retryLabel="إعادة المحاولة"
        />
    );
}

export default ServerErrorPage;
